import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ChevronUpIcon = _ref => {
  let {
    width = '8',
    height = '24'
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "8 9 8 5",
    width: width,
    height: height,
    "aria-hidden": true,
    children: /*#__PURE__*/_jsx("g", {
      id: "<Icon>",
      opacity: "0.51",
      children: /*#__PURE__*/_jsx("path", {
        id: "Vector",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.221 9.322L8.29201 12.277C8.1052 12.4659 8.00043 12.7208 8.00043 12.9865C8.00043 13.2522 8.1052 13.5071 8.29201 13.696C8.38375 13.7892 8.49311 13.8631 8.61371 13.9136C8.73432 13.9641 8.86376 13.9901 8.99451 13.9901C9.12526 13.9901 9.2547 13.9641 9.3753 13.9136C9.49591 13.8631 9.60526 13.7892 9.69701 13.696L11.995 11.379L14.302 13.706C14.394 13.7991 14.5035 13.873 14.6243 13.9234C14.7451 13.9739 14.8746 13.9999 15.0055 13.9999C15.1364 13.9999 15.266 13.9739 15.3867 13.9234C15.5075 13.873 15.617 13.7991 15.709 13.706C15.8956 13.517 16.0002 13.2621 16.0002 12.9965C16.0002 12.7309 15.8956 12.476 15.709 12.287L12.769 9.322C12.5623 9.11629 12.2827 9.00056 11.991 9C11.712 9 11.434 9.107 11.221 9.322Z",
        fill: "currentColor"
      })
    })
  });
};